// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ClimateRiskSelectionState {
  // Climate risk is a path-routed lens with no query-param selection state; extend as needed.
}

function serializeSelectionState(_state: ClimateRiskSelectionState) {
  return undefined;
}

function unserializeSelectionState(_value: string | undefined): ClimateRiskSelectionState {
  return {};
}

function isImpactHighlighted() {
  return false;
}

export const climateRiskLensSelectionState = {
  serializeSelectionState,
  unserializeSelectionState,
  isImpactHighlighted,
};
